import { FC } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';
import { TextFieldSizeVariantsType } from '@beeline/design-system-react/types/components/TextField/TextField.types';

import clsx from 'clsx';

import classes from './FieldSkeleton.module.scss';

export interface FieldSkeletonProps {
  size?: TextFieldSizeVariantsType;
}

export const FieldSkeleton: FC<FieldSkeletonProps> = ({ size = 'medium' }) => {
  return <Skeleton className={clsx(classes[size], classes.border)} />;
};
